import { CastType } from 'constants/castTypes';
import { ClientDataType } from 'utils/dataTypes';
import { ComparatorType } from './Comparators';
import { DataTypeType } from './DataType';

export enum Combinator {
  AND = 'And',
  OR = 'Or',
  NOT = 'Not',
}

export enum FieldType {
  BOOLEAN = 'boolean',
  CAMPAIGN_LABEL_ID = 'campaignLabelId',
  DATE = 'date',
  FLOAT = 'double',
  GEO_LOCATION = 'geo_location',
  INTEGER = 'long',
  KEYWORD = 'keyword', // ES5StringType string value (see ESFieldMapping.scala)
  OBJECT = 'object',
  STRING = 'string', // ES1StringType string value
  NESTED = 'nested',
  UNDEFINED = 'undefined',
}

export type BaseSearchField = {
  dataType: ClientDataType;
  comparatorType: ComparatorType;
  field: string;
};

export type SingleValueSearchField = BaseSearchField & {
  value: string;
  fieldType?: FieldType;
  castType?: CastType;
};

export type MultiValueSearchField = BaseSearchField & {
  values: string[];
};

export enum IterableDistanceUnit {
  kilometers = 'km',
  miles = 'mi',
}
export type GeoLocation = { lon: number; lat: number };
export type GeoDistance = { distance: number; unit: IterableDistanceUnit };

export type GeoSearchField = BaseSearchField & {
  location: GeoLocation;
  distance: GeoDistance;
};

export type AnyGeoSearchField = BaseSearchField & {
  locations: GeoLocation[];
  distance: GeoDistance;
};

export type SearchField =
  | SingleValueSearchField
  | MultiValueSearchField
  | GeoSearchField
  | AnyGeoSearchField;

export type SearchCombo = {
  combinator: Combinator;
  searchQueries: SearchField[];
};

export type DataTypeSearchCombo = {
  dataType: DataTypeType;
  maxMatch?: number;
  minMatch?: number;
  searchCombo: SearchCombo;
};

export type SearchQuery = {
  combinator: Combinator;
  searchQueries: SearchQuery[] | DataTypeSearchCombo[];
};

export type SegmentQuery = {
  orderBy?: string;
  page?: number;
  pageSize: number;
  searchQuery: SearchQuery;
  sorting?: string;
};
